module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('em', [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img1"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("St. Louis")]), _vm._v(" departing Hamburg, May 13, 1939")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img2"
    }
  }, [_vm._v("Captain Gustav Schroeder")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img3"
    }
  }, [_vm._v("A picture postcard sold to the refugees")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img4"
    }
  }, [_vm._v("The social hall of the "), _c('em', [_vm._v("St. Louis")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img5"
    }
  }, [_vm._v("Front-page headline of the May 1939 issue of "), _c('em', [_vm._v("Der Stuermer")]), _vm._v(", the Nazi propaganda sheet: “Jews Emigrate”")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img6"
    }
  }, [_vm._v("The refugees board the "), _c('em', [_vm._v("St. Louis")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img7"
    }
  }, [_vm._v("Lilly Joseph")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img8"
    }
  }, [_vm._v("Ten-year-old Liesl Joseph")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img9"
    }
  }, [_vm._v("June 18, 1939, the day after her eleventh birthday, Liesl Joseph was presented with a bouquet of two dozen roses by Morris Troper")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img10"
    }
  }, [_vm._v("Children who traveled alone on the "), _c('em', [_vm._v("St. Louis:")]), _vm._v(" seven-year-old Renatta Aber and her five-year-old sister Evelyne")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img11"
    }
  }, [_vm._v("The Spanier twins")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img12"
    }
  }, [_vm._v("The passenger committee")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch07.htm#img13"
    }
  }, [_vm._v("Otto Schiendick")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img14"
    }
  }, [_vm._v("Arrival in Havana")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img15"
    }
  }, [_vm._v("In Havana Harbor, friends and relatives shout up to the passengers on the "), _c('em', [_vm._v("St. Louis")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img16"
    }
  }, [_vm._v("Cuban guards stop the passengers from leaving the ship")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img17"
    }
  }, [_vm._v("Aboard the "), _c('em', [_vm._v("St. Louis")]), _vm._v(" in Havana Harbor")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img18"
    }
  }, [_vm._v("Cuban President Frederico Bru (left) and army chief Fulgencio Batista")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img19"
    }
  }, [_vm._v("Arrival in Antwerp")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img20"
    }
  }, [_vm._v("According to "), _c('em', [_vm._v("Der Stuermer")]), _vm._v(", the “happy Jews” as they departed on the "), _c('em', [_vm._v("St. Louis")]), _vm._v(", and on their return to Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ch25.htm#img21"
    }
  }, [_vm._v("Captain Schroeder makes his last visit to the bombed-out hulk of the "), _c('em', [_vm._v("St. Louis")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baa8d504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/illustrations.vue
// module id = 72
// module chunks = 0